<template>
  <div class="screen-wrapper" :style="screenWrapperStyle">
    <div class="screen" :style="screenStyle">
      <img
        class="rectangle"
        alt="Rectangle"
        src="/static/img/zhaoping-rectangle-148387.svg"
      />
      <img
        class="img"
        alt="Rectangle"
        src="/static/img/zhaoping-rectangle-148419.png"
      />
      <img
        class="mask-group"
        alt="Mask group"
        src="/static/img/zhaoping-mask-group.png"
      />
      <img
        class="mask-group-2"
        alt="Mask group"
        src="/static/img/zhaoping-mask-group-1.png"
      />

      <div
        class="group"
        v-anim="'animate__fadeInUp'"
        style="animation-delay: 0.15s"
      >
        <div class="text-wrapper-4">Recruitment .</div>
        <div class="heading-services">招贤纳士</div>
      </div>
      <HeaderSubsection
        :fixed="true"
        :logoSrc="'/static/img/zhaoping-image-506@2x.png'"
      />

      <div class="text-wrapper-2" v-anim="'animate__fadeInDown'" style="animation-delay: 0.1s">招贤纳士</div>
      <div class="div-gradient" v-anim="'animate__fadeInRight'" style="animation-delay: 0.15s"></div>
      <p class="element-UP-NICE">
        <span>团队大部分伙伴毕业于</span>
        <span class="bold">985/211</span>
        <span>
          院校，覆盖小学到高中阶段课程体系 每年四次课时费UP机会、晋升机会多
          氛围、福利、收入、发展、老板超NICE。
        </span>
      </p>

      <div class="features">
        <div class="title-cn">我们的特点</div>
        <div class="title-en">Features</div>
      </div>

      <img
        class="image-2"
        alt="Image"
        src="/static/img/zhaoping-image-530@2x.png"
        v-anim="'animate__fadeInUp'"
        style="animation-delay: 0.2s"
      />
      <div class="group-3" v-anim style="animation-delay: 0.25s">
        <div class="group-4">
          <div class="heading-services-3">薪酬福利</div>
          <div class="text-wrapper-6">Compensation And Benefits</div>
        </div>
        <div class="text-wrapper-7">云帆培优</div>
        <div class="auto-flex">
          <div class="flexcontainer">
            <p class="text">
              <span class="text-wrapper-8"
                >石家庄教育机构中的一匹黑马，团队大部分伙伴毕业于 </span
              ><span class="text-wrapper-9">985/211</span
              ><span class="text-wrapper-8"> 院校，</span>
            </p>
            <p class="text">
              <span class="text-wrapper-8"
                >覆盖小学到高中阶段课程体系，每年四次课时费UP机会、晋升机会多氛围、福利、收入、发展、老板超NICE。</span
              >
            </p>
          </div>
          <div class="group-5" />
        </div>
        <div class="group-6">
          <img
            class="rectangle-4"
            alt="Rectangle"
            src="/static/img/zhaoping-rectangle-107.png"
          />
          <img
            class="rectangle-5"
            alt="Rectangle"
            src="/static/img/zhaoping-rectangle-108.png"
          />
          <img
            class="rectangle-6"
            alt="Rectangle"
            src="/static/img/zhaoping-rectangle-109.png"
          />
          <div class="rectangle-7" />
          <div class="rectangle-8" />
          <div class="rectangle-9" />
          <div class="group-7">
            <div class="text-wrapper-10">成长</div>
            <div class="PM">
              开放的晋升通道<br />专业/管理技能学习培训<br />职业通道（PM双通道）<br />年度评优
            </div>
          </div>
          <div class="group-8">
            <div class="text-wrapper-11">学校福利</div>
            <div class="text-wrapper-12">
              保障：五险一金、年度体检、子女报班优惠<br />暖心：节日礼品、团建基金、生日福利、结婚礼金<br />假期：法定假、带薪年假、福利假
            </div>
          </div>
          <div class="group-9">
            <div class="text-wrapper-13">薪资构成</div>
            <div class="element">
              基本薪酬：有竞争力的底薪；<br />课时费：高于行业水平的课时费标准；
              浮动激励：每年4次课时费晋级窗口；
            </div>
          </div>
        </div>
      </div>

      <div class="div-wrapper">
        <div class="group-14">
          <div class="heading-services-3">工作环境</div>
          <div class="text-wrapper-6">Working Environment</div>
        </div>
      </div>

      <img
        class="group-15"
        alt="Group"
        src="/static/img/zhaoping-group-1420069541.png"
      />

      <div class="rectangle-13" />

      <div class="group-16" v-anim style="animation-delay: 0.3s">
        <div class="group-17">
          <div class="heading-services-3">文化活动</div>
          <div class="text-wrapper-6">Cultural Activities</div>
        </div>
      </div>

      <img
        class="rectangle-14"
        alt="Rectangle"
        src="/static/img/zhaoping-rectangle-1484141.png"
        v-anim="'animate__fadeInUp'"
        style="animation-delay: 0.35s"
      />
      <img
        class="rectangle-15"
        alt="Rectangle"
        src="/static/img/zhaoping-rectangle-1484151@2x.png"
        v-anim="'animate__fadeInUp'"
        style="animation-delay: 0.4s"
      />
      <img
        class="rectangle-16"
        alt="Rectangle"
        src="/static/img/zhaoping-rectangle-1484161@2x.png"
        v-anim="'animate__fadeInUp'"
        style="animation-delay: 0.45s"
      />
      <img
        class="rectangle-17"
        alt="Rectangle"
        src="/static/img/zhaoping-rectangle-1484171@2x.png"
        v-anim="'animate__fadeInUp'"
        style="animation-delay: 0.5s"
      />
      <img
        class="rectangle-18"
        alt="Rectangle"
        src="/static/img/zhaoping-rectangle-1484181@2x.png"
        v-anim="'animate__fadeInUp'"
        style="animation-delay: 0.55s"
      />

      <ZhaopingClassroomSubsection />
      <ZhaopingTestBasisSubsection />

      <Group3Subsection :top="footerTop" />
    </div>
  </div>
</template>

<script>
import HeaderSubsection from "../Screen/sections/HeaderSubsection.vue";
import Group3Subsection from "../Screen/sections/Group3Subsection.vue";
import ZhaopingClassroomSubsection from "./sections/ZhaopingClassroomSubsection.vue";
import ZhaopingTestBasisSubsection from "./sections/ZhaopingTestBasisSubsection.vue";

export default {
  name: "ZhaopingScreen",
  components: {
    HeaderSubsection,
    Group3Subsection,
    ZhaopingClassroomSubsection,
    ZhaopingTestBasisSubsection,
  },
  directives: {
    anim: {
      inserted(el, binding) {
        const cls = binding && binding.value ? binding.value : "animate__fadeInUp";
        el.classList.add("animate__animated");
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((e) => {
              if (e.isIntersecting) {
                el.classList.add(cls);
                io.unobserve(el);
              }
            });
          },
          { threshold: 0.2 }
        );
        io.observe(el);
      },
    },
  },
  data() {
    return {
      baseWidth: 1920,
      baseHeight: 2050,
      viewportWidth: 0,
      viewportHeight: 0,
      footerTop: 4700,
    };
  },
  computed: {
    scale() {
      const w = this.viewportWidth || this.baseWidth;
      const clamped = Math.min(w, this.baseWidth);
      return clamped / this.baseWidth;
    },
    screenStyle() {
      const minBase = Math.max(
        this.baseHeight,
        this.viewportHeight || this.baseHeight
      );
      return {
        transform: `scale(${this.scale})`,
        transformOrigin: "top center",
        width: this.baseWidth + "px",
        position: "relative",
        minHeight: minBase / this.scale + "px",
      };
    },
    screenWrapperStyle() {
            const minBase = Math.max(
        this.baseHeight,
        this.viewportHeight || this.baseHeight
      );
      return {
        height: minBase / this.scale + "px",
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
      };
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
    this.$nextTick(() => this.updateFooterTop());
  },
  methods: {
    onResize() {
      this.viewportWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      this.viewportHeight =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight;
    },
    updateFooterTop() {
      const contentBottom = 4686;
      const viewBase =
        (this.viewportHeight || this.baseHeight) / (this.scale || 1);
      const footerHeight = 233;
      const desired = Math.max(contentBottom + 60, viewBase - footerHeight);
      this.footerTop = Math.round(desired);
    },
  },
};
</script>

<style scoped>
.screen {
  min-width: 1920px;
  position: relative;
  width: 100%;

}
.screen-wrapper {
  width: 100%;
  position: relative;
  overflow-x: hidden;
  min-height: 100vh;
}
.rectangle {
  height: 955px;
  left: 0;
  position: absolute;
  top: 620px;
  width: 1920px;
}
.img {
  height: 955px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 620px;
  width: 1920px;
}
.mask-group {
  height: 620px;
  left: 0;
  position: absolute;
  top: 0;
  width: 1920px;
}
.mask-group-2 {
  height: 559px;
  position: absolute;
  right: 180px;
  top: 878px;
  width: 1560px;
}
.group {
  display: flex;
  flex-direction: column;
  gap: 32px;
  height: 98px;
  left: 180px;
  position: absolute;
  top: 740px;
  width: 494px;
}
.text-wrapper-4 {
  color: #00183c;
  font-family: "Poppins", Helvetica;
  font-size: 72px;
  font-weight: 600;
  height: 36px;
  letter-spacing: 0;
  line-height: 36px;
  white-space: nowrap;
  width: 490px;
}
.heading-services {
  align-items: center;
  color: #00183c;
  display: flex;
  font-family: "PingFang SC-Regular", Helvetica;
  font-size: 32px;
  font-weight: 400;
  height: 30px;
  justify-content: center;
  letter-spacing: 0;
  line-height: 30px;
  white-space: nowrap;
  width: 128px;
}
.text-wrapper-2 {
  color: #ffffff;
  font-family: "PingFang SC-Medium", Helvetica;
  font-size: 36px;
  font-weight: 500;
  left: 885px;
  letter-spacing: 1.8px;
  line-height: 54px;
  position: absolute;
  top: 283px;
  white-space: nowrap;
}
.div-gradient {
  background: linear-gradient(
    90deg,
    rgba(0, 86, 183, 0) 0%,
    rgba(1, 92, 211, 1) 100%
  );
  height: 368px;
  position: absolute;
  right: 180px;
  top: 1067px;
  width: 1560px;
}
.element-UP-NICE {
  color: #ffffff;
  font-family: "PingFang SC-Regular", Helvetica;
  font-size: 24px;
  font-weight: 400;
  left: 885px;
  letter-spacing: 0;
  line-height: 56px;
  position: absolute;
  top: 1217px;
  width: 852px;
}
.element-UP-NICE .bold {
  font-size: 32px;
  font-weight: 700;
}
.features {
  height: 57px;
  left: 885px;
  position: absolute;
  top: 1128px;
  width: 244px;
}
.features .title-cn {
  color: #ffffff;
  font-family: "PingFang SC-Semibold", Helvetica;
  font-size: 48px;
  font-weight: 400;
  line-height: 30px;
  position: absolute;
  top: 0;
  left: 0;
}
.features .title-en {
  color: #ffffff4c;
  font-family: "PingFang SC-Semibold", Helvetica;
  font-size: 48px;
  font-weight: 400;
  line-height: 30px;
  position: absolute;
  top: 27px;
  left: 0;
}
.image-2 {
  aspect-ratio: 1;
  height: 451px;
  left: 170px;
  object-fit: cover;
  position: absolute;
  top: 1759px;
  width: 451px;
}
.cards {
  position: absolute;
  top: 1715px;
  left: 170px;
  width: 1580px;
  height: 461px;
}
.rectangle-4 {
  height: 314px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 500px;
}
.rectangle-5 {
  height: 314px;
  left: 540px;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 500px;
}
.rectangle-6 {
  height: 314px;
  left: 1080px;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 500px;
}
.group-3 {
  display: flex;
  flex-direction: column;
  height: 912px;
  left: 170px;
  position: absolute;
  top: 1715px;
  width: 1584px;
}
.group-4 {
  height: 57px;
  position: relative;
  width: 644px;
}
.heading-services-3 {
  align-items: center;
  color: #1c4b8a;
  display: flex;
  font-family: "PingFang SC-Semibold", Helvetica;
  font-size: 48px;
  font-weight: 400;
  height: 30px;
  justify-content: center;
  left: 0;
  letter-spacing: 0;
  line-height: 30px;
  position: absolute;
  top: 0;
  white-space: nowrap;
}
.text-wrapper-6 {
  align-items: center;
  color: #00000014;
  display: flex;
  font-family: "PingFang SC-Semibold", Helvetica;
  font-size: 48px;
  font-weight: 400;
  height: 30px;
  justify-content: center;
  left: 0;
  letter-spacing: 0;
  line-height: 30px;
  position: absolute;
  top: 27px;
  white-space: nowrap;
}
.text-wrapper-7 {
  color: #333333;
  font-family: "Noto Sans SC", Helvetica;
  font-size: 24px;
  font-weight: 700;
  height: 26px;
  letter-spacing: 0;
  line-height: 26px;
  margin-left: 790px;
  margin-top: 49px;
  white-space: nowrap;
  width: 96px;
}
.auto-flex {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 65px;
  margin-left: 790px;
  margin-top: 22px;
  min-height: 185px;
  width: 532px;
}
.flexcontainer {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 108px;
  position: relative;
  width: 532px;
}
.text {
  align-self: stretch;
  color: #333333;
  font-family: "Noto Sans SC", Helvetica;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 32px;
  position: relative;
}
.text-wrapper-8 {
  color: #333333;
  font-family: "Noto Sans SC", Helvetica;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 32px;
}
.text-wrapper-9 {
  font-weight: 700;
}
.group-5 {
  background-color: #ffffff;
  border-radius: 6px;
  height: 12px;
  margin-right: 192px;
  width: 12px;
}
.group-6 {
  height: 461px;
  margin-top: 112px;
  position: relative;
  width: 1580px;
}
.rectangle-7 {
  background-color: #ffffffe6;
  border: 1.01px solid;
  border-color: #f0f0f0;
  border-radius: 4px;
  box-shadow: 0 0 20.25px #0000000a;
  height: 247px;
  left: 1131px;
  position: absolute;
  top: 214px;
  width: 401px;
}
.rectangle-8 {
  background-color: #ffffffe6;
  border: 1.01px solid;
  border-color: #f0f0f0;
  border-radius: 4px;
  box-shadow: 0 0 20.25px #0000000a;
  height: 247px;
  left: 589px;
  position: absolute;
  top: 214px;
  width: 401px;
}
.rectangle-9 {
  background-color: #ffffffe6;
  border: 1.01px solid;
  border-color: #f0f0f0;
  border-radius: 4px;
  box-shadow: 0 0 20.25px #0000000a;
  height: 247px;
  left: 49px;
  position: absolute;
  top: 214px;
  width: 401px;
}
.group-7 {
  display: flex;
  flex-direction: column;
  gap: 28px;
  height: 198px;
  left: 1161px;
  position: absolute;
  top: 248px;
  width: 345px;
}
.text-wrapper-10 {
  color: #0f2020;
  font-family: "Noto Sans SC", Helvetica;
  font-size: 24px;
  font-weight: 500;
  height: 26px;
  letter-spacing: 0;
  line-height: 26px;
  white-space: nowrap;
  width: 55px;
}
.PM {
  color: #606060;
  font-family: "Noto Sans SC", Helvetica;
  font-size: 18px;
  font-weight: 400;
  height: 144px;
  letter-spacing: 0;
  line-height: 36px;
  width: 341px;
}
.group-8 {
  display: flex;
  flex-direction: column;
  gap: 28px;
  height: 198px;
  left: 619px;
  position: absolute;
  top: 248px;
  width: 353px;
}
.text-wrapper-11 {
  color: #0f2020;
  font-family: "Noto Sans SC", Helvetica;
  font-size: 24px;
  font-weight: 500;
  height: 26px;
  letter-spacing: 0;
  line-height: 26px;
  white-space: nowrap;
  width: 96px;
}
.text-wrapper-12 {
  color: #606060;
  font-family: "Noto Sans SC", Helvetica;
  font-size: 18px;
  font-weight: 400;
  height: 144px;
  letter-spacing: 0;
  line-height: 36px;
  width: 349px;
}
.group-9 {
  display: flex;
  flex-direction: column;
  gap: 28px;
  height: 171px;
  left: 78px;
  position: absolute;
  top: 248px;
  width: 346px;
}
.text-wrapper-13 {
  color: #0f2020;
  font-family: "Noto Sans SC", Helvetica;
  font-size: 24px;
  font-weight: 500;
  height: 26px;
  letter-spacing: 0;
  line-height: 26px;
  white-space: nowrap;
  width: 96px;
}
.element {
  color: #606060;
  font-family: "Noto Sans SC", Helvetica;
  font-size: 18px;
  font-weight: 400;
  height: 108px;
  letter-spacing: 0;
  line-height: 36px;
  width: 341px;
}
.div-wrapper {
  display: flex;
  height: 57px;
  left: 170px;
  position: absolute;
  top: 2867px;
  width: 491px;
}
.group-14 {
  height: 57px;
  position: relative;
  width: 495px;
}
.group-15 {
  height: 1px;
  left: 617px;
  position: absolute;
  top: 3582px;
  width: 516px;
}
.rectangle-13 {
  background-color: #f7f8fa;
  height: 1030px;
  left: 0;
  position: absolute;
  top: 3656px;
  width: 1920px;
}
.group-16 {
  display: flex;
  height: 57px;
  left: 170px;
  position: absolute;
  top: 3810px;
  width: 405px;
}
.group-17 {
  height: 57px;
  position: relative;
  width: 409px;
}
.rectangle-14 {
  height: 628px;
  left: 170px;
  object-fit: cover;
  position: absolute;
  top: 3971px;
  width: 460px;
}
.rectangle-15 {
  height: 299px;
  left: 654px;
  object-fit: cover;
  position: absolute;
  top: 3971px;
  width: 460px;
}
.rectangle-16 {
  height: 299px;
  left: 1138px;
  object-fit: cover;
  position: absolute;
  top: 3971px;
  width: 460px;
}
.rectangle-17 {
  height: 299px;
  left: 654px;
  object-fit: cover;
  position: absolute;
  top: 4300px;
  width: 460px;
}
.rectangle-18 {
  height: 299px;
  left: 1138px;
  object-fit: cover;
  position: absolute;
  top: 4300px;
  width: 460px;
}
</style>
